"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3170],{

/***/ 3170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeWarrantyRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



function HomeWarrantyRight() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-20 gap-6 lg:mt-32 mt-16 lg:mb-48 mb-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[621px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-4 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "block w-[6px] h-[42px] bg-[#F6CEBE]"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "font-bold lg:text-3xl text-xl lg:leading-[45px] ",
                                children: "Is a Home Warranty Right for You?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-5 font-light lg:text-lg text-base lg:leading-8 text-[#505050]",
                        children: "A home warranty is an ideal service for homeowners seeking to safeguard their household appliances and systems from unexpected breakdowns and repairs. It is particularly beneficial for those who lack expertise in repairs or find it challenging to allocate time for maintenance tasks. With a home warranty, homeowners can have peace of mind knowing that their home systems are covered in case of unforeseen breakdowns."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[260px] h-[150px] md:w-[447px] md:min-w-[447px] md:h-[255px] relative mx-auto lg:mx-0 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/homewarranty.center/assets/images/homeWarrantyRightImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ })

}]);